import { RoutePermittedRole } from "shared/constants/AppConst";
import Users from "./users";
import UserIndex from "./users/UserCreate";
import UserUpdateIndex from "./users/UserUpdate";
import { isModuleAuthorized } from "@crema/utility/Utils";
import Error403 from "pages/errorPages/Error403";

export const userConfig = [
  {
    permittedRole: RoutePermittedRole.User,
    path: "/master/manageUser",
    exact: true,
    element: isModuleAuthorized("Manage Users") ? <Users /> : <Error403 />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/master/manageUser/users",
    exact: true,
    element: isModuleAuthorized("Manage Users") ? <Users /> : <Error403 />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/master/manageUser/UserCreate",
    exact: true,
    element: isModuleAuthorized("Add User") ? <UserIndex /> : <Error403 />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/master/manageUser/userUpdate/:id",
    exact: true,
    element: isModuleAuthorized("Edit User") ? <UserUpdateIndex /> : <Error403 />,
  },
];
